import request from '@/utils/request'
//逝者关系
export function fetchRelationshipList(data) {
  return request({
     url: '/app/memorialInfo/memorialInfoReqDetail',
    method: 'post',
    data
  })
}